
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arbeidsgiver/[narmestelederid]/[oppfolgingsdialogId]/seplanen",
      function () {
        return require("private-next-pages/arbeidsgiver/[narmestelederid]/[oppfolgingsdialogId]/seplanen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arbeidsgiver/[narmestelederid]/[oppfolgingsdialogId]/seplanen"])
      });
    }
  